<template>
  <div v-if="organizations.length > 0">
    <div class="container">
      <!-- schools -->
      <div v-if="
              $canManageOrganization(
                $store.getters.user.Permissions,
                topOrg.Organization_Id
              )
            ">
        <div class="row">
          <div class="col-auto">
            <h6 class="text-secondary mb-0 pt-2">{{ topOrg.Organization_Type.Organization_Type_Id == 3 ? "School" : "Company" }}</h6>
          </div>
          <div class="col" />
          <div class="col-auto">
            <button
              class="btn btn-sm btn-primary mb-1"
              data-toggle="modal"
              v-bind:data-target="
                '#inviteUserModal' +
                  topOrg.Organization_Id
              "
            >
              Add User
            </button>
          </div>
        </div>
        <div style="background-color:gray; height:1px; width:100%" />
        <div class="container text-left">
          <div
            v-for="organization in organizations.filter(
              o => o.Organization_Type.Organization_Type_Id == topOrg.Organization_Type.Organization_Type_Id
            )"
            :key="organization.Organization_Id"
          >
            <div class="row">
              <div class="col-auto">
                <h6
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      organization.Organization_Id
                    )
                  "
                  class="pointer btn-link d-inline-block"
                  v-on:click="editOrganization(organization)"
                >
                  <b>
                    {{ organization.Name }}
                  </b>
                </h6>
                <h6 v-else class="d-inline-block">
                  {{ organization.Name }}
                </h6>
              </div>
              <div class="col-auto">
                <h6 class="text-secondary d-inline-block ml-2">
                  ({{ organization.Users.length }} Users)
                </h6>
              </div>
              <div class="col-auto">
                <button
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      organization.Organization_Id
                    )
                  "
                  class="btn btn-sm btn-primary"
                  v-on:click="
                    $emit('manage-organization-permissions', organization)
                  "
                >
                  User Permissions
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-secondary mb-0">
                  Name
                </p>
              </div>
              <div class="col">
                <p class="text-secondary mb-0">
                  Email
                </p>
              </div>
              <div class="col">
                <p class="text-secondary mb-1">
                  Phone
                </p>
              </div>
            </div>

            <div
              class="row"
              v-for="user in organization.Users"
              :key="'user' + user.User_Id"
            >
              <div class="col">
                <p
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      organization.Organization_Id
                    )
                  "
                  class="mb-1 pointer btn-link"
                  v-on:click="editUser(user)"
                >
                  {{ user.First_Name }} {{ user.Last_Name }}
                </p>
                <p v-else class="mb-1">
                  {{ user.First_Name }} {{ user.Last_Name }}
                </p>
              </div>
              <div class="col">
                <p class="mb-1">
                  {{ user.Email }}
                </p>
              </div>
              <div class="col">
                <p class="mb-1">
                  {{ user.Phone }}
                </p>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <h6 class="text-secondary mb-0 pt-2">
                  Groups
                </h6>
              </div>
              <div class="col-auto">
                <button
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      organization.Organization_Id
                    )
                  "
                  v-on:click="addOrganization(organization, orgSubType.toString())"
                  class="btn btn-sm btn-primary"
                >
                  Add Group
                </button>
              </div>
            </div>
            <div
              class="mt-1"
              style="background-color:gray; height:1px; width:100%"
            />
            <div
              v-for="schoolGroup in organizations.filter(
                o => o.Organization_Type.Organization_Type_Id == orgSubType
              )"
              :key="schoolGroup.Organization_Id"
              class="row container"
            >
              <div class="col-auto">
                <button
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      schoolGroup.Organization_Id
                    )
                  "
                  class="btn btn-link px-0"
                  v-on:click="editOrganization(schoolGroup)"
                >
                  {{ schoolGroup.Name }}
                </button>
                <p v-else class="mb-2">{{ schoolGroup.Name }}</p>
              </div>
              <div class="col-auto">
                <button
                  v-if="
                    $canManageOrganization(
                      $store.getters.user.Permissions,
                      schoolGroup.Organization_Id
                    )
                  "
                  class="btn btn-sm btn-primary"
                  v-on:click="
                    $emit('manage-organization-permissions', schoolGroup)
                  "
                >
                  User Permissions
                </button>
              </div>
              <div class="col" />
            </div>
          </div>
        </div>
      </div>

    </div>
    <InviteUserModal
      v-bind:Organizations="organizations"
      v-bind:Permissions="Permissions"
      v-bind:AccountId="AccountId"
      v-bind:ModalId="
        organizations.find(o => o.Organization_Type.Organization_Type_Id == 3 || o.Organization_Type.Organization_Type_Id == 4)
          .Organization_Id
      "
      @user-added="userAdded"
    />
    <AddEditOrganizationModal
      v-bind:OrganizationType="addOrganizationType"
      v-bind:ParentOrganizationId="parentOrganizationId"
      v-bind:AccountId="AccountId"
      v-bind:Organization="organizationToEdit"
      @added-org="orgAdded"
      @edited-org="orgEdited"
      @edit-closed="editOrgClosed"
      @deleted-org="orgDeleted"
    />
  </div>
</template>

<script>
import AddEditOrganizationModal from "@/modals/Account/AddEditOrganizationModal.vue";
import InviteUserModal from "@/modals/Organization/InviteUserModal.vue";
import $ from "jquery";

export default {
  props: {
    AccountId: String,
    AccountType: Object,
    AccountVariables: Object,
    Organizations: Array,
    Permissions: Array
  },
  components: {
    AddEditOrganizationModal,
    InviteUserModal
  },
  data: function() {
    return {
      organizations: this.Organizations,
      organizationToEdit: null,
      userToEdit: null,
      parentOrganizationId: "",
      addOrganizationType: null,
      topOrg: this.Organizations.find(o => o.Organization_Type.Organization_Type_Id == 3 || o.Organization_Type.Organization_Type_Id == 4),
      orgSubType: this.Organizations.find(o => o.Organization_Type.Organization_Type_Id == 3 || o.Organization_Type.Organization_Type_Id == 4).Organization_Type.Organization_Type_Id == 3 ? 6 : 7
    };
  },
  mounted() {},
  methods: {
    addOrganization(parentOrganization, organizationTypeId) {
      this.addOrganizationType = this.AccountVariables.Organization_Types.find(
        t => t.Organization_Type_Id == organizationTypeId
      );
      this.parentOrganizationId = parentOrganization.Organization_Id;
      this.organizationToEdit = null;
      $("#addEditOrganizationModal" + this.AccountId).modal("show");
    },
    editOrganization(organization) {
      this.addOrganizationType = null;
      this.parentOrganizationId = "";
      this.organizationToEdit = organization;
      $("#addEditOrganizationModal" + this.AccountId).modal("show");
    },
    orgAdded(newOrg) {
      this.organizations.push(newOrg);
    },
    orgEdited(editedOrg) {
      var editingIndex = this.organizations.findIndex(
        o => o.Organization_Id == editedOrg.Organization_Id
      );
      this.$set(this.organizations, editingIndex, editedOrg);
    },
    orgDeleted(orgId) {
      var deletedIndex = this.organizations.findIndex(
        o => o.Organization_Id == orgId
      );
      this.organizations.splice(deletedIndex, 1);
    },
    editOrgClosed() {
      this.organizationToEdit = null;
    },
    editUser(user) {
      this.userToEdit = user;
      $("#editAccountUserModal").modal("show");
    },
    userAdded(newUser) {
      var newUserName = newUser.First_Name + " " + newUser.Last_Name;
      var orgIndex = this.organizations.findIndex(
        o => o.Organization_Id == newUser.Organization.Organization_Id
      );
      this.organizations[orgIndex].Users.push(newUser);
      this.$showSnackbar(
        "A user account was created and an email was sent to " + newUserName,
        false
      );
    },
    userEdited(editedUser) {
      var oldOrgIndex = this.organizations.findIndex(o =>
        o.Users.map(u => u.User_Id).includes(editedUser.User_Id)
      );
      var oldUserIndex = this.organizations[oldOrgIndex].Users.findIndex(
        u => u.User_Id == editedUser.User_Id
      );

      if (this.userToEdit.Organization_Id == editedUser.Organization_Id) {
        this.$set(this.organizations[oldOrgIndex], oldUserIndex, editedUser);
      } else {
        this.organizations[oldOrgIndex].Users.splice(oldUserIndex, 1);

        var editingOrgIndex = this.organizations.findIndex(
          o => o.Organization_Id == editedUser.Organization_Id
        );
        this.organizations[editingOrgIndex].Users.push(editedUser);
      }
    }
  }
};
</script>
